import { z } from "zod";

/**
 * Demo-library manifest — the static catalog the SPA's DemoSource consumes
 * (plan §5/§6). Produced by @rago/demo-content, served at /demo/manifest.json.
 * All paths are relative to the /demo/ root.
 */

export const demoImageSchema = z.object({
  width: z.number().int().positive(),
  path: z.string().min(1),
});

export const demoSubtitleSchema = z.object({
  lang: z.string().min(2).max(8),
  label: z.string().min(1),
  path: z.string().min(1),
});

export const demoItemSchema = z.object({
  id: z.string().regex(/^[a-z0-9-]+$/),
  guid: z.string().startsWith("demo://movie/"),
  title: z.string().min(1),
  sortTitle: z.string().min(1),
  year: z.number().int(),
  summary: z.string(),
  genres: z.array(z.string()),
  runtimeMs: z.number().int().positive(),
  externalIds: z.array(
    z.object({ provider: z.enum(["tmdb", "imdb"]), id: z.string() }),
  ),
  attribution: z.object({
    holder: z.string(),
    license: z.string(),
    licenseUrl: z.string(),
    sourceUrl: z.string(),
  }),
  addedAt: z.string(),
  images: z.object({
    poster: z.array(demoImageSchema).min(1),
    backdrop: z.array(demoImageSchema).min(1),
  }),
  playback: z.object({
    direct: z.object({
      path: z.string(),
      container: z.string(),
      videoCodec: z.string(),
      audioCodec: z.string(),
      width: z.number().int(),
      height: z.number().int(),
      sizeBytes: z.number().int(),
    }),
    hls: z.object({ masterPath: z.string() }).nullable(),
  }),
  subtitles: z.array(demoSubtitleSchema),
});
export type DemoItem = z.infer<typeof demoItemSchema>;

export const demoManifestSchema = z.object({
  version: z.literal(1),
  generatedAt: z.string(),
  library: z.object({ id: z.string(), title: z.string() }),
  attributionNote: z.string(),
  items: z.array(demoItemSchema),
});
export type DemoManifest = z.infer<typeof demoManifestSchema>;
